import { useState } from 'react';
import { useT } from '../context/LocaleContext';
import { formatWhen } from '../lib/format';
import BookingReschedulePanel from './BookingReschedulePanel';
import Sheet from './Sheet';

export default function BookingRescheduleDialog({ booking, onRescheduled }) {
  const t = useT();
  const [open, setOpen] = useState(false);

  if (!booking) return null;

  return (
    <>
      <button
        type="button"
        className="reschedule-trigger"
        onClick={() => setOpen(true)}
      >
        <span className="material-symbol" aria-hidden="true">
          event_repeat
        </span>
        <span className="reschedule-trigger-copy">
          <strong>{t('reschedule.title')}</strong>
          <small>{formatWhen(booking.scheduled_at || booking.created_at)}</small>
        </span>
        <span className="material-symbol reschedule-trigger-chevron" aria-hidden="true">
          chevron_right
        </span>
      </button>

      {open ? (
        <Sheet
          variant="modal"
          title={t('reschedule.title')}
          subtitle={t('reschedule.current', {
            when: formatWhen(booking.scheduled_at || booking.created_at),
          })}
          onClose={() => setOpen(false)}
        >
          <BookingReschedulePanel
            booking={booking}
            embedded
            onRescheduled={(scheduledAt) => {
              onRescheduled?.(scheduledAt);
              setOpen(false);
            }}
          />
        </Sheet>
      ) : null}
    </>
  );
}
